import { AiFillLinkedin } from "react-icons/ai";
import { RiTwitterXFill } from "react-icons/ri";
import { HiOutlineMail } from "react-icons/hi";
import { FaArrowRight, FaDownload } from "react-icons/fa";
import Typist from "react-typist-component";
import { Tilt } from "react-tilt";

const Hero = () => {
  const navigate = (link: string) => window.open(link, "_blank");

  const downloadResume = () => {
    const link = document.createElement("a");
    link.href = "/Arsh_resume.pdf";
    link.download = "Arsh_Ahmad_Resume.pdf";
    link.click();
  };

  const tiltOptions = {
    reverse: false,
    max: 25,
    perspective: 1000,
    scale: 1.05,
    speed: 1000,
    transition: true,
    axis: null,
    reset: true,
    easing: "cubic-bezier(.03,.98,.52,.99)",
  };

  return (
    <section className="min-h-screen flex flex-col justify-center items-center relative py-10">
      <div className="text-center relative z-10">
        {/* Profile picture with rotating conic ring */}
        <div className="hero-enter-scale">
          <div className="relative w-36 h-36 md:w-44 md:h-44 mx-auto mb-6">
            <div className="absolute -inset-[3px] rounded-full animate-spin-slow bg-[conic-gradient(from_0deg,#14b8a6,#06b6d4,#0ea5e9,#14b8a6)]" />
            <div className="absolute -inset-[3px] rounded-full bg-[conic-gradient(from_0deg,#14b8a6,#06b6d4,#0ea5e9,#14b8a6)] blur-md opacity-60 animate-spin-slow" />
            <Tilt
              options={tiltOptions}
              className="relative bg-gradient-to-b from-teal-500 to-cyan-500 rounded-full w-full h-full overflow-hidden ring-2 ring-white dark:ring-gray-900"
            >
              <img
                className="object-cover w-full h-full"
                src="/profile-transparent.png"
                alt="Arsh Ahmad"
              />
            </Tilt>
          </div>
        </div>

        {/* Animated gradient name */}
        <h1 className="hero-enter hero-delay-1 text-5xl md:text-7xl font-bold">
          <span className="animate-gradient bg-gradient-to-r from-teal-500 via-cyan-400 to-teal-500 bg-clip-text text-transparent">
            Arsh Ahmad
          </span>
        </h1>

        <h2 className="hero-enter hero-delay-2 text-xl md:text-2xl text-gray-600 dark:text-gray-400 mt-3 font-medium tracking-wide">
          Software Engineer
        </h2>

        <div className="hero-enter hero-delay-3 max-w-2xl mx-auto mt-6 px-4">
          <p className="text-md md:text-lg leading-8 text-gray-600 dark:text-gray-400">
            <Typist>
              Building scalable,{" "}
              <span className="text-teal-500 font-medium">full-stack</span> web
              applications with{" "}
              <span className="text-teal-500 font-medium">
                React, TypeScript & Node.js
              </span>
              . Shipping faster with{" "}
              <span className="text-teal-500 font-medium">
                AI-powered workflows
              </span>
              .
            </Typist>
          </p>
        </div>

        {/* Primary calls to action */}
        <div className="hero-enter hero-delay-4 flex flex-wrap justify-center gap-3 mt-8">
          <a
            href="#experience"
            className="btn-sheen inline-flex items-center gap-2 bg-gradient-to-r from-teal-500 to-cyan-500 text-white px-6 py-3 rounded-xl text-sm font-semibold shadow-lg shadow-teal-500/25 hover:shadow-teal-500/40 transition-all hover:scale-105 active:scale-95"
          >
            View my experience
            <FaArrowRight className="text-xs" />
          </a>
          <button
            onClick={downloadResume}
            className="inline-flex items-center gap-2 border border-gray-300 dark:border-gray-700 text-gray-700 dark:text-gray-200 px-6 py-3 rounded-xl text-sm font-semibold hover:border-teal-500 hover:text-teal-600 dark:hover:text-teal-400 transition-all hover:scale-105 active:scale-95"
          >
            <FaDownload className="text-xs" />
            Download résumé
          </button>
        </div>

        {/* Socials */}
        <div className="hero-enter hero-delay-5 flex justify-center gap-4 mt-6">
          <button
            onClick={() => navigate("https://www.linkedin.com/in/btwitsarsh/")}
            className="p-3 rounded-full bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:text-[#0A66C2] hover:bg-blue-50 dark:hover:bg-gray-700 transition-all text-xl hover:scale-110 active:scale-95"
            aria-label="LinkedIn"
          >
            <AiFillLinkedin />
          </button>
          <button
            onClick={() => navigate("https://twitter.com/btw_itsarsh")}
            className="p-3 rounded-full bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-200 dark:hover:bg-gray-700 transition-all text-xl hover:scale-110 active:scale-95"
            aria-label="Twitter"
          >
            <RiTwitterXFill />
          </button>
          <button
            onClick={() => navigate("mailto:arshahmadhdi@gmail.com")}
            className="p-3 rounded-full bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:text-teal-500 hover:bg-teal-50 dark:hover:bg-gray-700 transition-all text-xl hover:scale-110 active:scale-95"
            aria-label="Email"
          >
            <HiOutlineMail />
          </button>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-gray-300 dark:border-gray-600 rounded-full flex justify-center pt-2">
          <div className="w-1.5 h-2.5 bg-teal-500 rounded-full" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
